import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PassengerInformation } from 'app/interfaces/journey-management/journey-management-object.interface';
import { RequestManagementObject } from 'app/interfaces/request-management/request-management-object.interface';
import * as short from 'short-uuid';

@Component({
    selector: 'passenger-dialog.component',
    templateUrl: './passenger-dialog.component.html',
    styleUrls: [
        './passenger-dialog.component.css'
    ]
})
export class PassengerDialogComponent {
    dialogTitle: string;
    passengerInfoForm: FormGroup;
    

    constructor(public dialogRef: MatDialogRef<PassengerDialogComponent>, private matSnackBar: MatSnackBar, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data?: PassengerInformation) {
        this.dialogTitle = data ? 'Update Passenger Information' : 'Add Passenger Information';
        let MOBILE_PATTERN = '[- +()0-9]+';
        this.passengerInfoForm = this.formBuilder.group({
            key: [short.generate()],
            name: ['', Validators.required],
            nationality: [''],
            passportNumber: [''],
            contactTelephoneNumber: ['',[Validators.pattern(MOBILE_PATTERN)]],
            contactEmail: ['', [Validators.required, Validators.email]],
        });

        if (this.data) {
            this.passengerInfoForm.patchValue(this.data);
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.passengerInfoForm.valid) {
            this.dialogRef.close(this.passengerInfoForm);
        }  else {
            this.passengerInfoForm.markAllAsTouched();
            this.openSnackBar('Required fields missing');
        }
    }

    private openSnackBar(message: string, action?: string) {
        this.matSnackBar.open(message, action, {
            duration: 2000,
        });
    }
}